import styled from 'styled-components';
import Colors from 'library/constants/colors';
import { ButtonMid, ParagraphMedium } from 'library/styles/text';
import { ButtonBaseStyles, ButtonSecondaryStyles, ButtonStyles } from '../../../../styles/button';
import { ShadowSlight } from '../../../../constants/styles-config';
import { IconBase } from '../../../../styles/icon';

export const CanvasContainer = styled.div`
  z-index: 4;
  position: relative;
  overflow: hidden;
  border-radius: 4px;
  ${({ isEmpty }) => (isEmpty ? `
    visibility: hidden;
    position: absolute;
    width: 1px;
    height: 1px;
  ` : `
    visibility: visible;
    position: relative;
    width: auto;
    height: auto;
    margin: 0 auto;
  `)};
`;

export const TriangleContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 2;

  &::after {
    width: 0;
    height: 0;
    position: absolute;
    bottom: -13px;
    left: calc(50% - 10px);
    border-style: solid;
    border-width: 10px 10px 0 10px;
    border-color: #fff transparent transparent transparent;
    content: '';
    display: block;
  }
`;

export const StyledCursor = styled.span`
  background-color: ${({ color }) => (color || 'transparent')};
  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out;
  will-change: transform;
  transform: ${({ clientX, clientY }) => `translate(${clientX}px, ${clientY - 10}px);`};
  position: absolute;
  top: -80px;
  left: -40px;
  display: block;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  border: 5px solid #fff;
  box-sizing: border-box;
  z-index: 5;
  pointer-events: none;
  box-shadow: ${ShadowSlight};
`;

export const StyledCanvas = styled.canvas`
  image-rendering: pixelated;
`;

export const Container = styled.div`
  padding: 32px 50px;
  background-color: ${Colors.shade07};
`;

export const PreviewBackground = styled.div`
  padding: 43px 50px;
  background-color: #fff;
  border-radius: 24px;
  text-align: center;
  box-shadow: ${ShadowSlight};

  ${ParagraphMedium} {
    margin-top: 8px;
  }
`;

export const Preview = styled.div`
  margin: 0 auto;
  display: block;
  cursor: pointer;
  width: auto;
  
  canvas {
    border-radius: 4px;
  }
`;

export const ButtonFile = styled.label`
  ${ButtonBaseStyles};
  ${ButtonMid};
  margin: 0 auto 24px;
  box-shadow: ${ShadowSlight};
  background-color: ${Colors.shade08};
  
  input {
    display: none;
  }
`;

export const Icon = styled(IconBase)`
  color: ${Colors.violet};
`;

export const Button = styled.button`
  ${ButtonStyles};
  width: calc(50% - 5px);
`;

export const ButtonPick = styled.button`
  ${ButtonSecondaryStyles};
  width: calc(50% - 5px);
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;

  &:disabled {
    cursor: not-allowed;
  }
`;
